export default {"src":"/_next/static/media/reusd.915101f2.svg","height":36,"width":36};